module.exports = __webpack_public_path__ + "img/pt-16.485fdf46.jpg";